import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";

import { MdEdit } from "react-icons/md";
import {
  createWaiter,
  getWaiters,
  selectSuccessWaiter,
  updateWaiter,
} from "../../redux/features/waiter/WaiterSlice";
import { BiPencil } from "react-icons/bi";

const CreateUpdateWaiter = ({ waiter }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [waiterName, setWaiterName] = useState("");
  const [errors, setErrors] = useState({});
  const isSuccess = useSelector(selectSuccessWaiter);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen && waiter) {
      setWaiterName(waiter.waiterName);
    }
  }, [waiter, isOpen]);

  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
    setWaiterName("");

    setErrors({});
  };

  const validateForm = () => {
    const newErrors = {};
    if (!waiterName) newErrors.waiterName = "Waiter Name is requried";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    if (waiter) {
      const waiterId = waiter._id;

      await dispatch(updateWaiter({ waiterId, waiterName }));
    } else {
      await dispatch(createWaiter(waiterName));
    }
  };

  useEffect(() => {
    if (isSuccess) {
      handleClose();
      dispatch(getWaiters());
    }
  }, [isSuccess, dispatch]);

  return (
    <div>
      {/* Button to open the modal */}

      {waiter ? (
        <button
          onClick={handleOpen}
          className="absolute text-white bg-[#20BEC6CC] rounded-lg p-[4px] top-2 right-2"
        >
          <BiPencil className="size-4" />
        </button>
      ) : (
        <button
          onClick={handleOpen}
          className="fixed bottom-8 right-8 md:w-14 w-10 md:h-14 h-10 bg-[#0D868C] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
        >
          <FaPlus className="md:text-xl text-[1rem]" />
        </button>
      )}

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] md:w-[550px] w-[90%] mx-auto p-10 space-y-6">
            <div className="flex justify-between items-center border-b-2 border-[#DEDEDE] pb-4 mb-8">
              <h1 className="md:text-[1.5rem] text-[1rem] font-bold text-[#0D868C]">
                {waiter ? "Update Waiter" : "Create Waiter"}
              </h1>
              <button type="button" onClick={handleClose}>
                <FiX className="md:size-8 size-5 text-[#0D868C]" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="mb-6 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Waiter Name
                </label>
                <input
                  value={waiterName}
                  onChange={(e) => setWaiterName(e.target.value)}
                  type="text"
                  placeholder="Enter the waiter name"
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
                {errors.waiterName && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.waiterName}
                  </p>
                )}
              </div>

              <div className="text-center mt-8">
                <button
                  type="submit"
                  className="text-white bg-[#0D868C] md:w-[50%] w-full py-3 rounded-full outline-none uppercase font-normal text-[1rem]"
                >
                  {waiter ? "Update Waiter" : "Create Waiter"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateUpdateWaiter;
